/* eslint-disable no-dupe-keys */
import { combineReducers } from 'redux';
import loginReducer from './loginReducer';
import posloginReducer from './posloginReducer.js';
import clientsListReducer from './clientsListReducer';
import clientByIdReducer from './clientByIdReducer.js';
import { parametersListReducer,parametersByClientReducer,parametersByIDReducer, parametersListByParaTypeReducer } from './parametersReducer';
import { screensReducer, screensByIdReducer } from './screensReducer.js'
import {  timerReducer } from './TimerReducer'
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import {posStorageReducer} from './posStorageReducer';
 
const persistConfig = {
    key: 'root',
    storage: storage,
    blacklist:['clientsList','parametersByClient','parametersList','parametersByID',]
  };

export default persistReducer(persistConfig,combineReducers({
    user:posloginReducer,
    user:loginReducer,
    clientsList:clientsListReducer,
    clientById:clientByIdReducer,
    parametersList:parametersListReducer,
    parametersListByParaType:parametersListByParaTypeReducer,
    parametersByClient:parametersByClientReducer,
    parametersByID:parametersByIDReducer,
    screens:screensReducer,
    screenById:screensByIdReducer,
    orderTimer:timerReducer,
    posStorage:posStorageReducer
}));

